import React, { FormEvent, SetStateAction, useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import Button from 'components/Button';
import styles from './Search.module.css';

type SearchProps = {
  setShowSearch: (show: SetStateAction<boolean>) => void;
  className?: string;
};

const Search = ({ setShowSearch, className }: SearchProps) => {
  const [search, setSearch] = useState<string>('');
  const router = useRouter();
  const isFirstRender = useRef(true);
  const inputSearchRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setShowSearch(false);
  }, [router]);

  useEffect(() => {
    if (inputSearchRef.current) {
      inputSearchRef.current.focus();
    }
  }, []);

  const searchHandler = async (e: FormEvent<HTMLFormElement>) => {
    e?.preventDefault();
    if (search.length < 1) {
      return;
    }
    await router.push(`/search?q=${search}`);
    setSearch('');
    setShowSearch(false);
  };

  const clearSearchInputHandler = () => {
    setSearch('');
    if (inputSearchRef.current) {
      inputSearchRef.current.focus();
    }
  };

  return (
    <>
      <form onSubmit={(e) => searchHandler(e)} className={`${styles.search}`}>
        <div className={`${styles.search__wrapper} ${className || ''}`}>
          <div className={styles.input__wrapper}>
            <input
              ref={inputSearchRef}
              className={styles.search__input}
              type="text"
              placeholder="Поиск вопроса"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              data-qa-marker="search_input"
            />
            {search.length > 0 && (
              <div
                className={styles.input_clear}
                onClick={() => clearSearchInputHandler()}
              />
            )}
          </div>
          <Button
            text=""
            onClick={(e) => searchHandler(e)}
            className={styles.search__find_btn}
          >
            <span className={styles.search__find_btn_content}>
              <img
                className={styles.search__icon}
                src="https://static.uchi.ru/files/otvety/headerV2/search_white.svg"
                alt="Иконка поиска"
              />
              Найти
            </span>
          </Button>
          <Button
            data-qa-marker="start_search_btn"
            type="default"
            text="Закрыть"
            onClick={() => setShowSearch(false)}
            className={styles.search__close_btn}
          />
        </div>
      </form>
    </>
  );
};

export default Search;
